import type { CSSObject } from "type/tss";
import { Theme } from "@mui/material/styles";
import { formFieldStyles } from "component/shared/form-fields/styles";

export const styles = (theme: Theme) => {
	return ({
		...formFieldStyles(theme),
		inputRoot: {
			paddingLeft: 0,
		},
		menuSwatch: {
			display: "inline-block",
			width: 16,
			height: 16,
			borderRadius: 2,
			marginRight: 12,
			flexShrink: 0,
		},
	} satisfies Record<string, CSSObject>);
};
